//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'product-tile-attributes',
  props: {
    attribute: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    className() {
      return this.attribute?.type ? `--${this.attribute?.type}` : ''
    },
    label() {
      return this.attribute?.label ? this.$t(this.attribute?.label) : ''
    },
    icon() {
      return this.attribute?.icon ?? ''
    },
  },
}
